import type { FunnelId } from './config';
import tiktok from './tiktok/i18n';

type LocaleMessages = Record<string, Record<string, string>>;

export const FUNNEL_I18N_OVERRIDES: Partial<Record<FunnelId, LocaleMessages>> = {
  tiktok,
};

export function resolveFunnelI18n(funnelId: FunnelId): LocaleMessages {
  return FUNNEL_I18N_OVERRIDES[funnelId] ?? {};
}
